import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
// import { Form } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
// import { Tooltip } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import * as PropTypes from "prop-types";
import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  DataTypeProvider,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableFilterRow,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";

import SVG from "react-inlinesvg";
import { Card, Tooltip, OverlayTrigger, Button, Modal, Container, Row, Col } from "react-bootstrap";

import moment from "moment-timezone";

import { roles, roleOptionsForSelect, icons } from "../../../../config/config";
import {
  medicalMutationPermissions,
  medicalPermissions,
} from "../../../../permissions/medicalPermissions";
import * as apiMedici from "../../../../api/medici";
import { EditNewMedico } from "./EditNewMedico";

import { Mailbox, Phone, Building, Person } from "react-bootstrap-icons";
import { ContactlessOutlined } from "@material-ui/icons";

const TableComponent = ({ ...restProps }) => (
  <Table.Table
    {...restProps}
    className="table table-hover table-head-custom table-vertical-center overflow-hidden"
  />
);

const TabellaToolbar = ({ addCallback, ...props }) => {
  return (
    <div {...props}>
      <Button onClick={addCallback} className="float-right">
        Aggiungi medico
      </Button>
    </div>
  );
};

const DateFormattedColumn = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => moment(value).format("DD MMMM YYYY")}
    {...props}
  />
);

const FilterCell = (props) => {
  const { column } = props;
  if (column.name === "actions") {
    const ActionsFilterCell = ({ filter, onFilter }) => (
      <th style={{ fontWeight: "normal" }}>
        <input disabled style={{ visibility: "hidden" }} />
      </th>
    );
    ActionsFilterCell.propTypes = {
      filter: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
      }),
      onFilter: PropTypes.func.isRequired,
    };
    ActionsFilterCell.defaultProps = {
      filter: null,
    };
    return <ActionsFilterCell {...props} />;
  }
  return <TableFilterRow.Cell {...props} />;
};
FilterCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

const DeleteModal = ({ name, show, hideCallback, deleteCallback }) => (
  <Modal show={show} onHide={hideCallback} className="card-custom gutter-b">
    <Modal.Header className="border-0 py-5 row">
      <Modal.Title>
        <h3 className="font-weight-bolder text-dark">Elimina medico</h3>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-4">
      Sei sicuro di voler eliminare definitivamente "{name}"
    </Modal.Body>
    <Modal.Footer className="border-0 py-5 row">
      <Button onClick={deleteCallback} variant="danger" className="float-right">
        Elimina
      </Button>
      <Button
        onClick={hideCallback}
        variant="secondary"
        className="float-right"
      >
        Annulla
      </Button>
    </Modal.Footer>
  </Modal>
);

// Columns definition
const mediciColumns = [
  { name: "fullname", title: "Nome" },
  { name: "agente", title: "Agente" },
  { name: "specializzazione", title: "Specializzazione" },
  { name: "email", title: "Email" },
  { name: "phone", title: "Telefono" },
  { name: "address", title: "Indirizzo" },
  // { name: "dateCreated", title: "Creato il" },
  { name: "actions", title: "Azioni" },
];

const defaultColumnWidths = [
  { columnName: "fullname", width: "220" },
  { columnName: "agente", width: "200" },
  { columnName: "specializzazione", width: "220" },
  { columnName: "email", width: "auto" },
  { columnName: "phone", width: 150 },
  { columnName: "address", width: "auto" },
  { columnName: "actions", width: 120 },
];

// Messages
const tableMessages = {
  noData: "Nessun medico disponibile",
};
const filterRowMessages = {
  filterPlaceholder: "Filtra...",
};
const pagingPanelMessages = {
  showAll: "Tutte",
  rowsPerPage: "Righe per pagina",
  info: "Da {from} a {to} ({count} medici)",
};

// Paging and sorting
const pageSizes = [10, 20, 30, 50];
const initialPageSize = 10;
const initialSorting = [
  { columnName: "lastname", direction: "asc" },
  { columnName: "firstname", direction: "asc" },
  { columnName: "agente", direction: "asc" }
];

export const Medici = () => {
  // table data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [_internalUpdateCount, _setInternalUpdateCount] = useState(0);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  const canMutateMedicalRecords = medicalMutationPermissions.includes(role);
  const canManageAllMedicalRecords = medicalPermissions.includes(role);
  const canMutateRow = (row) =>
    canMutateMedicalRecords &&
    (canManageAllMedicalRecords || String(row.idAgente) === String(user.id));

  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const ActionsColumn = ({ editCallback, deleteCallback }) => (
    <DataTypeProvider
      for={["actions"]}
      formatterComponent={({ value, row }) => {
        const canEdit = canMutateRow(row);
        return (
          <>
          {canEdit && (<OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Modifica</Tooltip>}
          >
            {/*eslint-disable-next-line*/}
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={(e) => {
                e.stopPropagation();
                editCallback(row.id);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl(icons.edit)} />
              </span>
            </a>
          </OverlayTrigger>
          )}
  
          <> </>
          {canEdit && (<OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Elimina</Tooltip>}
          >
            {/*eslint-disable-next-line*/}
            <a
              className="btn btn-icon btn-light btn-hover-danger btn-sm"
              onClick={(e) => {
                e.stopPropagation();
                deleteCallback(row.id);
              }
              }
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG src={toAbsoluteUrl(icons.delete)} />
              </span>
            </a>
          </OverlayTrigger>
          )}
        </>
      );
    }}
    />
  );

  const DetailModal = () => (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header className="bg-light">
        <Modal.Title className="text-secondary">
          <Container>
            <Row className="align-items-left">
              <Col className="text-left mb-3 mb-md-0">
                <Person size={64} />
              </Col>
              <Col md="auto">
                {selectedRow ? (
                  <>
                    <div>{selectedRow.fullname}</div>
                    <h5 className="text-black-50">
                      {selectedRow.specializzazione}
                    </h5>
                  </>
                ) : null}
              </Col>
            </Row>
          </Container>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedRow && (
          <div>
            <div className="input-group mb-3">
              <span className="input-group-text border-0 bg-white">
                <Mailbox size={20} />
              </span>
              <span className="form-control border-0">
                <strong></strong>{" "}
                <a
                  href={`mailto:${selectedRow.email}`}
                  className="text-decoration-none"
                >
                  {selectedRow.email}
                </a>
              </span>
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text border-0 bg-white">
                <Phone size={20} />
              </span>
              <span className="form-control border-0">
                <strong></strong>{" "}
                <a
                  href={`tel:${selectedRow.phone}`}
                  className="text-decoration-none"
                >
                  {selectedRow.phone}
                </a>
              </span>
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text border-0 bg-white">
                <Building size={20} />
              </span>
              <span className="form-control border-0">
                <strong></strong>{" "}
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    selectedRow.address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  {selectedRow.address}{" "}
                </a>
              </span>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );

  // nascondi colonna "agente" se non admin/magazziniere
  let columns =
    role === roles.admin || role === roles.gestore || role === roles.magazziniere
      ? mediciColumns
      : [mediciColumns[0], ...mediciColumns.slice(2)];
  if (!canMutateMedicalRecords) {
    columns = columns.filter((column) => column.name !== "actions");
  }

  // const shouldShowActions = rows.some((row) => (row.idAgente === user.id || role === roles.admin || role === roles.developer));
  // if (!shouldShowActions) {
  //   columns = columns.filter((col) => col.name != "actions");
  // }

  // const [columnWidths, setColumnWidths] = useState(() => {
  //   const saved = localStorage.getItem("mediciColumnWidths");
  //   return saved ? JSON.parse(saved) : defaultColumnWidths;
  // });

  // useEffect(() => {
  //   localStorage.setItem("mediciColumnWidths", JSON.stringify(columnWidths));
  // }, [columnWidths]);

  const TableRow = ({ row, ...restProps }) => (
    <Table.Row
      {...restProps}
      onClick={() => {
        setSelectedRow(row);
        setShowModal(true);
      }}
      style={{ cursor: "pointer" }}
    />
  );

  const updateFromServer = () => {
    setLoading(true);
    apiMedici
      .getAll(user.authToken)
      .then((data) => {
        if (Array.isArray(data)) {
          setRows(data.map((row) => ({
            ...row,
             actions: canMutateRow(row) ? row.id : null,
          }))
          );
        } else {
          setRows([]);
          console.error("Unexpected response format:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching medici:", error);
        setRows([]);
      })
      .finally(() => setLoading(false));
  };

  const triggerServerUpdate = () =>
    _setInternalUpdateCount(_internalUpdateCount + 1);

  useEffect(() => {
    updateFromServer();
    /*eslint-disable-next-line*/
  }, [_internalUpdateCount]);

  // edit page
  const [showEditPage, setShowEditPage] = useState(false);
  const [medicoForEdit, setMedicoForEdit] = useState(false);
  // delete modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // bind history to views to allow deep-linking
  const { location, push } = useHistory();

  useEffect(() => {
    if (!loading) {
      if (location.hash && location.hash === "#/new" && canMutateMedicalRecords) {
        setMedicoForEdit(false);
        setShowEditPage(true);
        setShowDeleteModal(false);
      } else if (location.hash && location.hash.startsWith("#/delete/")) {
        const idForEdit = parseInt(location.hash.substring(9));
        if (!isNaN(idForEdit)) {
          const row = rows.find((r) => r.id == idForEdit);
          if (row !== undefined && canMutateRow(row)) {
            setMedicoForEdit(row);
            setShowEditPage(false);
            setShowDeleteModal(true);
          }
        }
      } else if (location.hash && location.hash.startsWith("#/edit/")) {
        const idForEdit = parseInt(location.hash.substring(7));
        if (!isNaN(idForEdit)) {
          const row = rows.find((r) => r.id == idForEdit);
          if (row !== undefined && canMutateRow(row)) {
            setMedicoForEdit(row);
            setShowEditPage(true);
            setShowDeleteModal(false);
          }
        }
      } else {
        setMedicoForEdit(false);
        setShowEditPage(false);
        setShowDeleteModal(false);
      }
    }
    /*eslint-disable-next-line*/
  }, [location.hash, loading]);

  // paging and sorting
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [sorting, setSorting] = useState(initialSorting);

  if (!showEditPage) {
    return (
      <>
        <DeleteModal
          show={showDeleteModal}
          name={medicoForEdit.fullname}
          hideCallback={() => {
            push("#/");
          }}
          deleteCallback={() => {
            apiMedici.remove(user.authToken, medicoForEdit.id).then(() => {
              push("#/");
              triggerServerUpdate();
            });
          }}
        />
        <DetailModal></DetailModal>
        <Card className="card-custom gutter-b">
          <Card.Header className="border-0 py-5 row">
            <Card.Title className="float-left col-auto">
              <h3 className="font-weight-bolder text-dark">Medici</h3>
            </Card.Title>
             {canMutateMedicalRecords && (
               <TabellaToolbar
                 addCallback={() => {
                   push("#/new");
                 }}
                 className="float-right col-auto"
               />
             )}
          </Card.Header>
          <Card.Body className="pt-0">
            {loading ? (
              <Skeleton variant="rect" height={200} />
            ) : (
              <Grid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.uniqueId} // Assicurati che 'id' sia un identificatore unico per la riga
              >
                {(
                  <ActionsColumn
                    editCallback={(id) => {
                      push(`#/edit/${id}`);
                    }}
                    deleteCallback={(id) => {
                      push(`#/delete/${id}`);
                    }}
                  />
                )}

                <DateFormattedColumn for={["dateCreated"]} />
                <FilteringState />
                <IntegratedFiltering />
                <PagingState
                  currentPage={currentPage}
                  onCurrentPageChange={setCurrentPage}
                  pageSize={pageSize}
                  onPageSizeChange={setPageSize}

                />
                <IntegratedPaging />
                <SortingState sorting={sorting} onSortingChange={setSorting} />
                <IntegratedSorting />
                {/* {columnWidths.length > 0 && (
                  <TableColumnResizing
                    defaultColumnWidths={defaultColumnWidths}
                    columnWidths={columnWidths}
                    onColumnWidthsChange={setColumnWidths}
                  />
                )} */}
                <Table
                  messages={tableMessages}
                  tableComponent={TableComponent}
                  columnExtensions={defaultColumnWidths}
                  rowComponent={TableRow}
                />
                <TableHeaderRow showSortingControls />
                <TableFilterRow
                  messages={filterRowMessages}
                  cellComponent={FilterCell}
                />
                <PagingPanel
                  messages={pagingPanelMessages}
                  pageSizes={pageSizes}
                />
              </Grid>
            )
              // : (
              //   <div>
              //     <Skeleton variant="text" />
              //     <Skeleton variant="text" />
              //     <Skeleton variant="text" />
              //     <Skeleton variant="rect" height={518} />
              //   </div>
              // )
            }
          </Card.Body>
        </Card>
      </>
    );
  } else {
    function getBackPathFromHash(hash) {
      const pathAfterHash = hash.replace("#/", "");
      const parts = pathAfterHash.split("/");
      
      if (parts.includes("centro")) {
        return "/centri";
      } else {
        return "/medici";
      }
    }
    
    const backPath = getBackPathFromHash(location.hash);

    // Definisci hideEditPage
    const handleBack = () => {
      push(backPath);
    };

    return (
      <EditNewMedico
        token={user.authToken}
        medico={medicoForEdit}
        hideEditPage={handleBack}
        triggerServerUpdate={triggerServerUpdate}
      />
    );
  }
};
